import { VerificationCodeBatchSortByParam } from "@bvhi/backend-api";
import { GridSortItem } from "@bvhi/ui-base";
import { useCallback } from "react";

export interface SortConfig {
  backendString: string;
  dataGridSortModel: GridSortItem;
}

const config: SortConfig[] = [
  {
    backendString: VerificationCodeBatchSortByParam.CREATED_AT_ASC,
    dataGridSortModel: {
      field: "createdAt",
      sort: "asc",
    },
  },
  {
    backendString: VerificationCodeBatchSortByParam.CREATED_AT_DESC,
    dataGridSortModel: {
      field: "createdAt",
      sort: "desc",
    },
  },
  {
    backendString: VerificationCodeBatchSortByParam.NAME_ASC,
    dataGridSortModel: {
      field: "name",
      sort: "asc",
    },
  },
  {
    backendString: VerificationCodeBatchSortByParam.NAME_DESC,
    dataGridSortModel: {
      field: "name",
      sort: "desc",
    },
  },
  {
    backendString: VerificationCodeBatchSortByParam.VALID_UNTIL_ASC,
    dataGridSortModel: {
      field: "validUntil",
      sort: "asc",
    },
  },
  {
    backendString: VerificationCodeBatchSortByParam.VALID_UNTIL_DESC,
    dataGridSortModel: {
      field: "validUntil",
      sort: "desc",
    },
  },
];

export const useVerificationBatchSortParams = () => {
  const isFieldSortable = useCallback((fieldName: string): boolean => {
    const configItem = config.find((item) => item.dataGridSortModel.field === fieldName);
    if (configItem) return true;
    return false;
  }, []);

  const getSortModelForBackendString = useCallback((backendString: string): GridSortItem => {
    const item = config.find((item) => item.backendString === backendString);
    return item?.dataGridSortModel ?? config[0].dataGridSortModel;
  }, []);

  const getSortConfig = useCallback((sortModel?: GridSortItem) => {
    if (!sortModel) return config[0];
    const item = config.find((item) => item.dataGridSortModel.field === sortModel.field && item.dataGridSortModel.sort === sortModel.sort);
    return item ?? config[0];
  }, []);

  return { isFieldSortable, getSortConfig, getSortModelForBackendString };
};
